import * as s from "@gromia/components/theme/t.module.css";
import cx from "classnames";
import * as React from "react";

type Props = {
  line1: NonNullable<React.ReactNode>;
  line2: NonNullable<React.ReactNode>;
  line3: NonNullable<React.ReactNode>;
};

export function Quote(props: Props) {
  return (
    <div
      className={cx(
        s.bgWhite,
        s.rounded,
        s.shadow,
        s.mx3,
        s.p4,
        s.ptSm7,
        s.textAlignLeft,
      )}
    >
      <div
        className={cx(
          s.dFlex,
          s.flexColumn,
          s.flexSmRow,
          s.borderBottom,
          s.borderGray600,
        )}
      >
        <div>
          <OpeningQuote />
        </div>
        <div
          className={cx(
            s.fontSizeSmBig,
            s.fontItalic,
            s.pt5,
            s.ptSm0,
            s.plSm3,
            s.pb5,
            s.pbSm6,
          )}
        >
          {props.line1}”
        </div>
      </div>
      <div className={cx(s.pt3)}>
        <span
          className={cx(
            s.fontSizeBig,
            s.fontSizeSmLarge1,
            s.fontWeightSemiBold,
            s.textGray800,
          )}
        >
          {props.line2}
        </span>
        <span className={cx(s.fontSizeSmall1, s.textGray700)}>
          <span className={cx(s.px2)}>-</span>
          {props.line3}
        </span>
      </div>
    </div>
  );
}

function OpeningQuote() {
  return (
    <div
      className={cx(
        s.fontWeightSemiBold,
        s.overflowHidden,
        // s.border,
        // s.borderDanger,
      )}
      style={{
        fontSize: 96,
        lineHeight: 1,
        width: 39,
        height: 25,
        transform: "translate(0px, 6px)",
      }}
    >
      <div style={{ transform: "translate(0px, -16px)" }}>“</div>
    </div>
  );
}
